"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
const dialog_1 = __importDefault(require("../dialog"));
function placementStyle(placement) {
    switch (placement) {
        case "top":
            return {
                top: 0,
                right: 0,
                left: 0,
                maxWidth: "100vw",
            };
        case "right":
            return {
                top: 0,
                right: 0,
                width: "100%",
                height: "100vh",
            };
        case "bottom":
            return {
                right: 0,
                bottom: 0,
                left: 0,
                maxWidth: "100vw",
            };
        case "left":
            return {
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
            };
        default:
            return {};
    }
}
const useStyles = (0, create_use_styles_1.default)({
    drawer: ({ placement }) => ({
        ...placementStyle(placement),
        position: "fixed",
        borderRadius: 0,
    }),
});
exports.Drawer = react_1.default.forwardRef(function Drawer({ children, className, open = false, placement = "right", size = "small", ...props }, ref) {
    const classes = useStyles({ placement });
    return open ? (react_1.default.createElement(dialog_1.default, { ref: ref, className: (0, classnames_1.default)(classes.drawer, className), open: open, size: size, ...props }, children)) : null;
});
exports.default = exports.Drawer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHJhd2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy9kcmF3ZXIvZHJhd2VyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFBMEI7QUFDMUIsNERBQW9DO0FBRXBDLHdGQUE4RDtBQUM5RCx1REFBZ0Q7QUFRaEQsU0FBUyxjQUFjLENBQUMsU0FBb0I7SUFDMUMsUUFBUSxTQUFTLEVBQUU7UUFDakIsS0FBSyxLQUFLO1lBQ1IsT0FBTztnQkFDTCxHQUFHLEVBQUUsQ0FBQztnQkFDTixLQUFLLEVBQUUsQ0FBQztnQkFDUixJQUFJLEVBQUUsQ0FBQztnQkFDUCxRQUFRLEVBQUUsT0FBTzthQUNsQixDQUFDO1FBQ0osS0FBSyxPQUFPO1lBQ1YsT0FBTztnQkFDTCxHQUFHLEVBQUUsQ0FBQztnQkFDTixLQUFLLEVBQUUsQ0FBQztnQkFDUixLQUFLLEVBQUUsTUFBTTtnQkFDYixNQUFNLEVBQUUsT0FBTzthQUNoQixDQUFDO1FBQ0osS0FBSyxRQUFRO1lBQ1gsT0FBTztnQkFDTCxLQUFLLEVBQUUsQ0FBQztnQkFDUixNQUFNLEVBQUUsQ0FBQztnQkFDVCxJQUFJLEVBQUUsQ0FBQztnQkFDUCxRQUFRLEVBQUUsT0FBTzthQUNsQixDQUFDO1FBQ0osS0FBSyxNQUFNO1lBQ1QsT0FBTztnQkFDTCxHQUFHLEVBQUUsQ0FBQztnQkFDTixJQUFJLEVBQUUsQ0FBQztnQkFDUCxLQUFLLEVBQUUsTUFBTTtnQkFDYixNQUFNLEVBQUUsT0FBTzthQUNoQixDQUFDO1FBQ0o7WUFDRSxPQUFPLEVBQUUsQ0FBQztLQUNiO0FBQ0gsQ0FBQztBQUVELE1BQU0sU0FBUyxHQUFHLElBQUEsMkJBQWUsRUFBQztJQUNoQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLFNBQVMsRUFBNEIsRUFBRSxFQUFFLENBQUMsQ0FBQztRQUNwRCxHQUFHLGNBQWMsQ0FBQyxTQUFTLENBQUM7UUFDNUIsUUFBUSxFQUFFLE9BQU87UUFDakIsWUFBWSxFQUFFLENBQUM7S0FDaEIsQ0FBQztDQUNILENBQUMsQ0FBQztBQUVVLFFBQUEsTUFBTSxHQUFHLGVBQUssQ0FBQyxVQUFVLENBQThCLFNBQVMsTUFBTSxDQUNqRixFQUFFLFFBQVEsRUFBRSxTQUFTLEVBQUUsSUFBSSxHQUFHLEtBQUssRUFBRSxTQUFTLEdBQUcsT0FBTyxFQUFFLElBQUksR0FBRyxPQUFPLEVBQUUsR0FBRyxLQUFLLEVBQUUsRUFDcEYsR0FBRztJQUVILE1BQU0sT0FBTyxHQUFHLFNBQVMsQ0FBQyxFQUFFLFNBQVMsRUFBRSxDQUFDLENBQUM7SUFFekMsT0FBTyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQ1osOEJBQUMsZ0JBQU0sSUFBQyxHQUFHLEVBQUUsR0FBRyxFQUFFLFNBQVMsRUFBRSxJQUFBLG9CQUFVLEVBQUMsT0FBTyxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxJQUFJLEtBQU0sS0FBSyxJQUNsRyxRQUFRLENBQ0YsQ0FDVixDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7QUFDWCxDQUFDLENBQUMsQ0FBQztBQUVILGtCQUFlLGNBQU0sQ0FBQyJ9